import { USER_ACTIVITY_LOGS, USER_ACTIVITY_LOGS_EXPORT } from "../../../api";
import axiosInstance from "../../../axiosInstance";

export const getUserActivitylog = ({ page, limit, created_by, module_name, created_date, affected_username }) => onResponse => {
    try {
        axiosInstance.get(USER_ACTIVITY_LOGS, {
            params: {
                page: page,
                limit: limit,
                created_by: Array.isArray(created_by) ? created_by.join(',') : created_by,
                module_name: module_name,
                created_date: created_date,
                affected_username: affected_username
            }
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });
    } catch (error) {
        console.log(error);
    }
};

export const ExportUserActivitylog = ({ created_by, affected_username, module_name, action_type, created_date, meta_data, reference_number, comments, header_names }) => onResponse => {
    try {
        axiosInstance.get(USER_ACTIVITY_LOGS_EXPORT, {
            params: {
                created_by: Array.isArray(created_by) ? created_by.join(',') : created_by,
                affected_username: affected_username,
                module_name: module_name,
                action_type: action_type,
                created_date: created_date,
                meta_data: meta_data,
                reference_number: reference_number,
                comments: comments,
                header_names: Array.isArray(header_names) ? header_names.join(',') : header_names,

            }
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });
    } catch (error) {
        console.log(error);
    }
};